import React from 'react';
import './style/AboutMeCard.css';

import { FaRegIdCard, FaBook, FaBrain  } from 'react-icons/fa';
import { BsPersonSquare  } from 'react-icons/bs';

function AboutMeCard({handleOption}){

    return (
        <div className="options_container">
            <h2>About me</h2>
            <div className="options_selecctions">
            <div
                className="options impar"
                onClick={() => handleOption("Personal")}
            >
               Personal <i><FaRegIdCard/></i> 
            </div>
            <div
                className="options par"
                onClick={() => handleOption("Education")}
            >
                Education <i><FaBook/></i> 
            </div>
            <div
                className="options impar"
                onClick={() => handleOption("Profile")}
            >
                Profile <i><BsPersonSquare/></i>
            </div>
            <div
                className="options par"
                onClick={() => handleOption("Thought")}
            >
                Lateral thinking <i><FaBrain/></i> 
            </div>
            </div>
        </div>
    );
}

export default AboutMeCard;
